import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { parseSearch, getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
    pageSize = 50,
    cursorIndex,
    count = true,
    returnRepresentativeSearchPhrases = true,
    orderby,
  } = variables;

  const { descriptor } = locator;
  const {
    cid,
    aid,
    cpid,
    adgid,
  } = descriptor;

  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(cpid)
    .AdGroups.$withKey(adgid);

  const search = {
    top: pageSize,
    skip: cursorIndex,
    count,
    returnRepresentativeSearchPhrases,
    orderby,
  };

  const parsedSearch = {
    ...parseSearch(search, entity),
    returnrepresentativesearchphrases: returnRepresentativeSearchPhrases,
  };
  const searchCompact = _.omit(parsedSearch, x => _.isNull(x) || _.isUndefined(x));
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return `${entity.path}/SearchPhrases/Default.GridData${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}


function odataPayloadFactory(params) {
  const { variables } = params;
  const { data } = variables;

  return data;
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign:ad_group:search_phrase',
  verb: requestVerbs.POST,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  payloadFactoryFn: odataPayloadFactory,
  keySelector: searchPhrase => searchPhrase.Text,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: searchPhrase => searchPhrase.Text,
  processorFn: response => response.value,
});
